var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[_c('div',{staticClass:"mm",style:({ backgroundImage: 'url(' + _vm.getImagePath(_vm.imgName) + ')' })}),_c('div',{staticClass:"banner-img"},[_c('img',{attrs:{"src":_vm.getImagePath(_vm.imgName)}})]),_c('div',{staticClass:"banner-title"})])
}
var staticRenderFns = []

export { render, staticRenderFns }